<template>
  <div>
    <!-- iterate customer in checks-->
    <div v-if="isLoading">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle" variant="yellow" />
      </div>
    </div>
    <div v-else>
      <b-form-group>
        <b-form-checkbox
          v-for="customer in customers"
          v-model="customerFilter"
          :key="customer.value"
          :value="customer.id"
          name="flavour-3a"
          @change="onSelectedCustomer"
        >
          {{ customer.fullName }}
          <span v-if="customer.nickname">({{ customer.nickname }})</span>
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerFilter",
  props: ["customerSelected"],
  data() {
    return {
      customers: [],
      customerFilter: [],
      isLoading: false,
    };
  },
  watch: {
    customerSelected: {
      handler: function (val) {
        this.customerFilter = val;
      },
      deep: true,
    },
  },
  methods: {
    getAgents() {
      this.isLoading = true;
      this.$store
        .dispatch("GET_CUSTOMERS")
        .then((response) => {
          this.customers = response;
          this.customerFilter = this.customerSelected;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSelectedCustomer() {
      this.$emit("selectedCustomer", this.customerFilter);
    },
  },

  mounted() {
    this.getAgents();
  },
};
</script>

<style>
</style>
